import { getConsolidatedMenuBrand } from './restaurants';
import { getMenuUnificationFeatureFlag } from './session-storage';

export const getMenuVersion = (getState: Function) => {
  const { restaurant, taskRouter, menu, cachedMenu, config } = getState();
  const { selectedMenuVersion, prodLiveVersion, menuVersions } = menu || {};

  const isBrandMenu = getMenuUnificationFeatureFlag();

  let prpMenuVersion = '',
    prpMenuTitle = '',
    brandMenuVersion = '';

  if (isBrandMenu) {
    const restaurantCode = restaurant.selectedRestaurantDetails?.restaurantCode;
    // Mirror the fetch-side gate: when a brand key is derivable, the version
    // lives in the brand-keyed V2 cache; otherwise it's the per-restaurant one.
    const brandKey = getConsolidatedMenuBrand(
      restaurantCode || '',
      config?.CONSOLIDATED_MENU_BRANDS || [],
      config?.CONSOLIDATED_MENU_EXCLUDED_RESTAURANTS || []
    );

    if (brandKey) {
      // Version is per-restaurant (V2 tracks it separately from the brand-keyed
      // menu cache, since a brand's stores can be on different versions).
      brandMenuVersion =
        cachedMenu.brandMenuVersionByRestaurant?.[restaurantCode || ''] || '';
    } else {
      const cachedEntry = cachedMenu.brandMenusOrder?.find(
        ({ restaurantId }: { restaurantId: string }) =>
          restaurantId === restaurantCode
      );
      brandMenuVersion = cachedEntry?.menuVersion || '';
    }
  } else {
    if (taskRouter?.currentTaskId) {
      const restaurantCode =
        restaurant.selectedRestaurantDetails?.restaurantCode;
      const cachedEntry = cachedMenu.menusOrder?.find(
        ({ restaurantId }: { restaurantId: string }) =>
          restaurantId === restaurantCode
      );

      const { menuVersion = '', menuTitle = '' } = cachedEntry || {};
      prpMenuVersion = menuVersion;
      prpMenuTitle = menuTitle;
    } else if (['', 'latest'].includes(selectedMenuVersion)) {
      const { commitId = '', comment = '' } = prodLiveVersion || {};

      prpMenuVersion = commitId;
      prpMenuTitle = comment;
    } else if (selectedMenuVersion) {
      prpMenuVersion = selectedMenuVersion;
      prpMenuTitle =
        menuVersions.find(
          ({ commitId }: { commitId: number }) =>
            commitId === selectedMenuVersion
        )?.comment || '';
    }
  }

  return {
    isBrandMenu,
    prpMenuVersion,
    prpMenuTitle,
    brandMenuVersion,
    menuVersion: isBrandMenu ? brandMenuVersion : prpMenuVersion,
  };
};
